import { inject } from '@angular/core'
import { CanActivateChildFn, Router } from '@angular/router'
import { AppStore } from '../app.store'
import { ToastrService } from 'ngx-toastr'
import { AccessLevel } from 'src/app/shared/interfaces/authentication/access-level.interface'

export const accessTypeGuard: CanActivateChildFn = (route, state) => {
    const appStore = inject(AppStore)
    const router = inject(Router)
    const toastr = inject(ToastrService)

    const me = appStore.me()

    if (!me || me.accessLevel === AccessLevel.FullAccess) {
        return true
    }

    toastr.error('Your account does not have access. Please contact an administrator.', 'Access Denied', {
        timeOut: 10_000,
    })

    router.navigateByUrl('/access-denied')
    return false
}
